module.exports = __webpack_public_path__ + "static/img/xls-dp-1.8ff54d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/xls-dp-1.png
// module id = u2EC
// module chunks = 0